import { API_BASE_URL } from "@/config";

// types
type HttpMethod = "GET" | "POST" | "PUT" | "PATCH" | "DELETE";
export type Payload = Record<string, any> | FormData | null;
export type ErrorHandler = ((response: Response) => Promise<never>) | undefined;

// POST
export function postRequest(endpoint: string, payload: Payload, errorHandler: ErrorHandler, includeCredentials: boolean = false): Promise<any> {
  return apiRequest(endpoint, "POST", payload, errorHandler, includeCredentials);
}

// GET
export function getRequest(endpoint: string, errorHandler: ErrorHandler, includeCredentials: boolean = false): Promise<any> {
  return apiRequest(endpoint, "GET", null, errorHandler, includeCredentials);
}

// PUT
export function putRequest(endpoint: string, payload: Payload, errorHandler: ErrorHandler, includeCredentials: boolean): Promise<any> {
  return apiRequest(endpoint, "PUT", payload, errorHandler, includeCredentials);
}

// PATCH
export function patchRequest(endpoint: string, payload: Payload, errorHandler: ErrorHandler, includeCredentials: boolean): Promise<any> {
  return apiRequest(endpoint, "PATCH", payload, errorHandler, includeCredentials);
}

// DELETE
export function deleteRequest(endpoint: string, payload: Payload = null, errorHandler: ErrorHandler, includeCredentials: boolean): Promise<any> {
  return apiRequest(endpoint, "DELETE", payload, errorHandler, includeCredentials);
}

// api request

export async function apiRequest(
  endpoint: string,
  method: HttpMethod,
  payload: Payload = null,
  errorHandler?: ErrorHandler,
  includeCredentials: boolean = false
): Promise<any> {
  try {
    const options: RequestInit = { method, headers: {} };

    if (includeCredentials) options.credentials = "include";

    if (payload instanceof FormData) {
      options.body = payload;
    } else if (payload != null) {
      (options.headers as Record<string, string>)["Content-Type"] = "application/json";
      options.body = JSON.stringify(payload);
    }

    const response = await fetch(`${API_BASE_URL}${endpoint}`, options);
    if (!response.ok && errorHandler) {
      await errorHandler(response);
    }

    // Kundenfeedback 16.10.2026 Teil 2 (XXXVII): 204 No Content hat keinen
    // Body – response.json() würde einen SyntaxError werfen. So blieb z. B.
    // die beendete Vor-Ort-Sitzung im Live-Panel „aktiv" hängen.
    if (response.status === 204) return null;

    return await response.json();
  } catch (err: any) {
    if (err.name === "TypeError") {
      throw new Error("Verbindungsfehler. Bitte überprüfen Sie Ihre Internetverbindung oder versuchen Sie es später erneut.");
    }

    throw err;
  }
}

// download

export async function apiDownload(endpoint: string, filename: string, errorHandler?: ErrorHandler): Promise<void> {
  try {
    const options: RequestInit = {
      method: "GET",
    };

    options.credentials = "include";

    const response = await fetch(`${API_BASE_URL}${endpoint}`, options);
    if (!response.ok && errorHandler) {
      await errorHandler(response);
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename || "download.pdf";
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (err: any) {
    if (err.name === "TypeError") {
      throw new Error("Verbindungsfehler. Bitte überprüfen Sie Ihre Internetverbindung oder versuchen Sie es später erneut.");
    }

    throw new Error(err.message);
  }
}
